/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { TaskResultState } from './TaskResultState';
const JobParser = /* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['state', TaskResultState],
    ['result', /* #__PURE__ */ parsers.maybeNull(codec.unknown)],
]);
export class Job extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return JobParser.decode(input).map(res => new Job(res));
    }
    static unsafeDecode(input) {
        return Job.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return JobParser.encode(data);
    }
    static schema() {
        return JobParser.schema();
    }
}
